import { render, staticRenderFns } from "./WidgetsConfiguration.vue?vue&type=template&id=e89f09f4&"
import script from "./WidgetsConfiguration.vue?vue&type=script&lang=js&"
export * from "./WidgetsConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports